module.exports = __webpack_public_path__ + "img/button-home5.653fc9c2.jpeg";